class Analytics {
    constructor() {      
    }

    init() {
        this.bindEvents();        
    }

    bindEvents() {
        this.pushAgentSelected();
        this.pushSlingShotVariables();
    }

    pushAgentSelected() {
        if (window.FB.AgentId) {
            //Place this code AFTER the GTM script. This code should fire when a user selects an agent
            dataLayer.push({
                event: 'Agent Selected',
                agent: window.FB.AgentId,
                agent_id: window.FB.AgentName
            });
        }
    }

    pushSlingShotVariables() {
         dataLayer.push({
            EBFBFSUID: window.Launchpad.uniqueSessionId,            
        });
    }
}

export default Analytics;